var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from 'mobx';
import UserActionsAPI from '../services/UserActionsAPI';
import _get from 'lodash/get';
import { transformDataForVehicles } from '../framework/DataTransformers';
import { ShowNotificationError } from '../framework/ErrorLogger';
class RecentlyStore {
    constructor() {
        Object.defineProperty(this, "recommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "statsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "recentlyCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "getRecommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.recommendationCars.length !== 0) {
                    return;
                }
                this.isFetching = true;
                return UserActionsAPI.getRecentlyCars()
                    .then((data) => {
                    this.recentlyCars = true;
                    const total = _get(data, 'total', 0);
                    const cars = _get(data, 'results');
                    if (!!total) {
                        for (let i = 0; i < cars.length; i++) {
                            this.recommendationCars.push(transformDataForVehicles(cars[i].car));
                        }
                        this.isFetching = false;
                    }
                    else {
                        UserActionsAPI.getPublicRecommendation()
                            .then((cars) => {
                            this.recentlyCars = false;
                            for (let i = 0; i < cars.length; i++) {
                                this.recommendationCars.push(transformDataForVehicles(cars[i]));
                            }
                            this.isFetching = false;
                        }).catch(() => {
                            this.recentlyCars = false;
                            this.isFetching = false;
                            return ShowNotificationError();
                        });
                    }
                }).then(() => this.getStatsData())
                    .catch((error) => {
                    this.recentlyCars = false;
                    this.isFetching = false;
                    return ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "getStatsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carIds) => {
                const recommendationCarIds = this.recommendationCars.map((carObj) => carObj.id);
                return UserActionsAPI.getStatsData(carIds || recommendationCarIds)
                    .then((response) => {
                    const aggStatsData = {};
                    response.data.forEach((data) => {
                        aggStatsData[data.carId] = data;
                    });
                    this.statsData.merge(aggStatsData);
                    return response.data;
                })
                    .catch((err) => {
                    ShowNotificationError('errors.loadStatistic');
                });
            }
        });
        makeObservable(this);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "recommendationCars", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "statsData", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "recentlyCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "getRecommendationCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], RecentlyStore.prototype, "getStatsData", void 0);
export default new RecentlyStore();
